module.exports = __webpack_public_path__ + "static/media/staking_bg.35319796.jpg";